import React from 'react'
import NavBar from './NavBar'


function Rooms() {
  return (
    <>
      <NavBar />
      <section className="hero-section">
        <p>Welcome to </p>
        <h1 style={{color:"#235784"}}> Rooms Page</h1>
      </section>
    </>
  )
}


export default Rooms

